import React from "react";
import { useLanguage } from "context/LanguageContext";
import SessionHub from "views/admin/sessions/SessionHub";

const UserSchedule = () => {
  const { t } = useLanguage();

  return (
    <div className="mt-5 flex flex-col gap-5">
      <h2 className="text-2xl font-bold text-ink">
        {t("mySchedule.title")}
      </h2>

      {/*
        Weekly session view: reuses the same week-navigation + day-grouped
        list UX as the staff-facing SessionHub, but in `readOnly` mode so
        no create/edit affordances or student-roster counts are exposed.
        Data sources (GET /sessions/feed, GET /classes) are already scoped
        server-side to the current STUDENT's own sessions/enrollments.
      */}
      <SessionHub readOnly />
    </div>
  );
};

export default UserSchedule;
